export default "__VITE_ASSET__CMzbVflS__"